import { Draggable } from '@hello-pangea/dnd';
import cn from 'classnames';
import type { FC, ReactNode } from 'react';

import Icon from '@/components/UI/Icon';
import RemoveButton from '@/components/UI/RemoveButton';

import './sortable.scss';

export interface SortableItemRemoveConfig {
  enabled: boolean;
  visible: boolean;
  onRemoveClick: () => void;
  removeButtonClasses?: string;
}

interface SortableItemProps {
  id: string;
  index: number;
  showDraggableIcon?: boolean;
  isDragDisabled?: boolean;
  className?: string;
  children: ReactNode;
  remove?: SortableItemRemoveConfig;
}

const SortableItem: FC<SortableItemProps> = ({
  id,
  index,
  showDraggableIcon = false,
  isDragDisabled = false,
  className = '',
  children,
  remove,
}) => {
  return (
    <Draggable draggableId={id} index={index} isDragDisabled={isDragDisabled}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          className={cn(className, {
            'o-90 b--moon-gray': snapshot.isDragging,
          })}
          data-dragging={snapshot.isDragging || undefined}
        >
          <div className="flex flex-row items-center flex-auto min-w-0">
            <div className="min-w-0 flex-auto">{children}</div>
            {showDraggableIcon ? (
              <div {...provided.dragHandleProps} className="movable flex items-center flex-shrink-0">
                <Icon icon="drag" className="dib mid-gray" width="20" height="20" />
              </div>
            ) : (
              <div {...provided.dragHandleProps} />
            )}
            {remove?.enabled === true ? (
              <div
                className="ml2 flex flex-shrink-0 items-center"
                onMouseDown={(e) => {
                  e.stopPropagation();
                }}
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <RemoveButton
                  className={cn('flex-shrink-0', remove.removeButtonClasses)}
                  style={{ visibility: remove.visible ? 'visible' : 'hidden' }}
                  onClick={remove.onRemoveClick}
                />
              </div>
            ) : null}
          </div>
        </div>
      )}
    </Draggable>
  );
};

export default SortableItem;
